import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  TextField,
  Typography,
  Button,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const DetailEdit = () => {
  const navigate = useNavigate();
  const { title_banner } = useParams();
  const [postData, setPostData] = useState({
    title_banner: '',
    id_bu_master: '',
    description_banner: '',
    logo_banner: null,
    images_banner: [],
    title_app: '',
    description_app: '',
    images_app: [],
    title_sec: '',
    description_sec: '',
    images_sec: [],
    title_prod_1: '',
    description_1: '',
    images_1: [],
    title_prod_2: '',
    description_2: '',
    images_2: [],
    title_prod_3: '',
    description_3: '',
    images_3: [],
    title_prod_4: '',
    description_4: '',
    images_4: [],
    gallery: [],
  });
  
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [buMasters, setBuMasters] = useState([]);

  const handleFileChange = (e, section) => {
    const files = Array.from(e.target.files);
    setPostData((prevData) => ({
      ...prevData,
      [section]: files,
    }));
  };

  const handleUpdate = async () => {

    if (
      !postData.title_banner ||
      !postData.id_bu_master ||
      !postData.description_banner ||
      !postData.logo_banner ||
      !postData.images_banner.length ||
      !postData.title_app ||
      !postData.description_app ||
      !postData.images_app.length ||
      !postData.title_sec ||
      !postData.description_sec ||
      !postData.images_sec.length ||
      !postData.title_prod_1 ||
      !postData.description_1 ||
      !postData.images_1.length ||
      !postData.title_prod_2 ||
      !postData.description_2 ||
      !postData.images_2.length ||
      !postData.title_prod_3 ||
      !postData.description_3 ||
      !postData.images_3.length ||
      !postData.title_prod_4 ||
      !postData.description_4 ||
      !postData.images_4.length
    ) {
      Swal.fire({
        title: 'Missing Information',
        text: 'Please fill in all the required fields and upload the images.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return; // Prevent submission if validation fails
    }

    const formData = new FormData();
    formData.append('id', postData.id);
    // Append form data
    formData.append('title_banner', postData.title_banner);
    formData.append('id_bu_master', postData.id_bu_master);
    formData.append('description_banner', postData.description_banner);
    if (postData.logo_banner) {
      formData.append('logo_banner', postData.logo_banner);
    }
    postData.images_banner.forEach((image) => {
      formData.append('images_banner', image);
    });

    // Handle App section
    formData.append('title_app', postData.title_app);
    formData.append('description_app', postData.description_app);
    postData.images_app.forEach((image) => {
      formData.append('images_app', image);
    });

    // Handle About section
    formData.append('title_sec', postData.title_sec);
    formData.append('description_sec', postData.description_sec);
    postData.images_sec.forEach((image) => {
      formData.append('images_sec', image);
    });

    // Handle Product section
    for (let i = 1; i <= 4; i++) {
      formData.append(`title_prod_${i}`, postData[`title_prod_${i}`]);
      formData.append(`description_${i}`, postData[`description_${i}`]);
      postData[`images_${i}`].forEach((image) => {
        formData.append(`images_${i}`, image);
      });
    }

    // Handle Gallery section
    postData.gallery.forEach((image) => {
      formData.append('gallery', image);
    });

     // Log the formData content
  console.log('Form Data:', [...formData]);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(`https://3wzg6m6x-5000.asse.devtunnels.ms/api/bu_detail/edit`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Show success alert
      Swal.fire({
        title: 'Success!',
        text: 'Business Unit successfully updated!',
        icon: 'success',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/compro/Bisnis-Unit-Detail');
      });

    } catch (error) {
      console.error('Error updating post:', error.response);
      setSnackbarMessage('Failed to update Business Unit: ' + (error.response?.data?.message || 'An unexpected error occurred.'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const fetchBuMasters = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://3wzg6m6x-5000.asse.devtunnels.ms/api/bu_master', {
        headers: {
          Authorization: `${token}`
        }
      });
      setBuMasters(response.data);
    } catch (error) {
      console.error("Error fetching BU Masters:", error);
      setSnackbarMessage('Error fetching BU Masters: ' + error.message);
      setSnackbarOpen(true);
    }
  };

  const fetchBusinessUnitData = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`https://3wzg6m6x-5000.asse.devtunnels.ms/api/bu_detail`, {
        headers: {
          Authorization: ` Bearer ${token}`,
        },
      });
      const data = response.data.find((item) => item.title_banner === title_banner); // Adjust this according to your API response structure
      if (data) {
        setPostData((prevData) => ({
          ...prevData,
          ...data,
          id: data.id, // Ensure this is being set
        }));
      } else {
        console.error('Business unit not found for the given title_banner:', title_banner);
      }
    } catch (error) {
      setSnackbarOpen(true);
      console.error('Error fetching business unit data:', error);
    }
  };
  
  useEffect(() => {
    fetchBuMasters();
    fetchBusinessUnitData();
  }, []);

  return (
    <Grid container spacing={2} sx={{ backgroundColor: 'white', p: 3, borderRadius: 2}}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ fontSize: '24px', }}>Edit Business Unit</Typography>
      </Grid>
      <Grid item xs={12}>
          <Grid container spacing={2}>
            {/* Column 1 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" mb={2}>App Section</Typography>
              <TextField
                label="Title Banner"
                fullWidth
                value={postData.title_banner}
                onChange={(e) => setPostData({ ...postData, title_banner: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel sx={{ color: 'gray' }}>Business Unit</InputLabel>
                <Select
                  value={postData.id_bu_master}
                  onChange={(e) => setPostData({ ...postData, id_bu_master: e.target.value })}
                >
                  {buMasters.map((bu) => (
                    <MenuItem key={bu.id} value={bu.id}>{bu.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Description Banner"
                fullWidth
                multiline
                value={postData.description_banner}
                onChange={(e) => setPostData({ ...postData, description_banner: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <div style={{ marginBottom: '20px' }}>
                <Typography variant="body1">Logo Banner Upload</Typography>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setPostData({ ...postData, logo_banner: e.target.files[0] })}
                />
              </div>
              <div style={{ marginBottom: '20px', }}>
                <Typography variant="body1">Image Banner Upload</Typography>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileChange(e, 'images_banner')}
                />
              </div>
            </Grid>

            {/* Column 2 */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" mb={2}>App Section</Typography>
              <TextField
                label="Title App"
                fullWidth
                value={postData.title_app}
                onChange={(e) => setPostData({ ...postData, title_app: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <TextField
                label="Description App"
                fullWidth
                multiline
                value={postData.description_app}
                onChange={(e) => setPostData({ ...postData, description_app: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <div style={{ marginBottom: '6px' }}>
                <Typography variant="body1">Image App Upload</Typography>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileChange(e, 'images_app')}
                />
              </div>
            </Grid>
          </Grid>

          {/* About Section */}
          <Typography variant="subtitle1" mb={2}>About Section</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Title About"
                fullWidth
                value={postData.title_sec}
                onChange={(e) => setPostData({ ...postData, title_sec: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <TextField
                label="Description About"
                fullWidth
                multiline
                value={postData.description_sec}
                onChange={(e) => setPostData({ ...postData, description_sec: e.target.value })}
                sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
              />
              <div style={{ marginBottom: '20px' }}>
                <Typography variant="body1">Image About Upload</Typography>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileChange(e, 'images_sec')}
                />
              </div>
            </Grid>
          </Grid>

          {/* Product Section */}
          <Typography variant="subtitle1" mb={2}>Product Section</Typography>
          <Grid container spacing={2}>
            {Array.from({ length: 4 }, (_, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <TextField
                  label={`Title Product ${index + 1}`}
                  fullWidth
                  value={postData[`title_prod_${index + 1}`]}
                  onChange={(e) => setPostData({ ...postData, [`title_prod_${index + 1}`]: e.target.value })}
                  sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
                />
                <TextField
                  label={`Description Product ${index + 1}`}
                  fullWidth
                  multiline
                  value={postData[`description_${index + 1}`]}
                  onChange={(e) => setPostData({ ...postData, [`description_${index + 1}`]: e.target.value })}
                  sx={{ mb: 2, '& .MuiInputLabel-root': { color: 'gray' } }}
                />
                <div style={{ marginBottom: '20px' }}>
                  <Typography variant="body1">{`Image Product ${index + 1} Upload`}</Typography>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => handleFileChange(e, `images_${index + 1}`)}
                  />
                </div>
              </Grid>
            ))}
          </Grid>

          {/* Gallery Section */}
          <Typography variant="subtitle1" mb={2}>Gallery Section</Typography>
          <div style={{ marginBottom: '20px' }}>
            <Typography variant="body1">Gallery Image Upload</Typography>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={(e) => handleFileChange(e, 'gallery')}
            />
          </div>

          {/* Submit Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button variant="contained" onClick={handleUpdate}>Update Business Unit</Button>
          </Box>
      </Grid>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default DetailEdit;
